import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type WishlistItem, wishlistItem } from "../schemas/wishlistItem";

export const getWishlistItemProps = z
  .object({
    token: z.string(),
    productId: z.string(),
  })
  .extend(requestConfig.shape);

export type GetWishlistItemProps = z.infer<typeof getWishlistItemProps>;

export const getWishlistItem = async (
  args: GetWishlistItemProps,
): Promise<WishlistItem[]> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    productId,
    proxyAuthSecret,
  } = parseServiceInput(getWishlistItemProps, args);
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist/${productId}`, {
    method: "GET",
    headers,
  });

  return parseServiceOutput(response, z.array(wishlistItem), {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
